import { CheckmarkCircledIcon } from '@/src/assets/icons'
import { FlexRow } from '@/src/components'
import { appColors } from '@/src/theme'
import { formatMeasurement } from '@/src/utils/formatMeasurement'
import { ChevronRightIcon } from '@chakra-ui/icons'
import type { UseToastOptions } from '@chakra-ui/react'
import { Box, Button, Flex, Text } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

type LoadPlanningSaveToastProps = {
  onClose: () => void
  onNavigate?: () => void
  consumptionDifference: number
}

const LoadPlanningSaveToast = ({ onClose, onNavigate, consumptionDifference }: LoadPlanningSaveToastProps) => {
  const { t } = useTranslation()
  const sign = consumptionDifference >= 0 ? '+' : '-'
  const absQuantity = formatMeasurement(Math.abs(consumptionDifference), 'kWh', 1)
  const signWord =
    consumptionDifference >= 0
      ? t('components.procurement.forecasting.save_success_toast.more')
      : t('components.procurement.forecasting.save_success_toast.less')

  return (
    <Box
      position='fixed'
      bottom={4}
      left='50%'
      transform='translateX(-50%)'
      zIndex={9999}
      bg='green.600'
      color='white'
      px={4}
      py={3}
      borderRadius='md'
      boxShadow='md'
      width={'1130px'}
    >
      <Flex align='center' justifyContent='space-between' gap={3}>
        <FlexRow alignItems='center' gap={2}>
          <CheckmarkCircledIcon width={'20px'} height={'20px'} />
          <Text fontSize='sm' opacity={0.9}>
            {t('components.procurement.forecasting.save_success_toast.message', {
              sign,
              absQuantity,
              signWord,
            })}
          </Text>
        </FlexRow>
        <Button
          borderColor={appColors.border}
          backgroundColor={appColors.background}
          borderWidth={1}
          borderRadius='8px'
          size='sm'
          onClick={() => {
            onNavigate?.()
            onClose()
          }}
          rightIcon={<ChevronRightIcon width={'20px'} height={'20px'} />}
        >
          {t('components.procurement.forecasting.save_success_toast.portfolio_overview_button')}
        </Button>
      </Flex>
    </Box>
  )
}

type CreateLoadPlanningSaveToastOptionsArgs = {
  onNavigate?: () => void
  consumptionDifference: number
}

export const createLoadPlanningSaveToastOptions = ({
  onNavigate,
  consumptionDifference,
}: CreateLoadPlanningSaveToastOptionsArgs): UseToastOptions => ({
  duration: 6000,
  isClosable: true,
  render: ({ onClose }) => (
    <LoadPlanningSaveToast onClose={onClose} onNavigate={onNavigate} consumptionDifference={consumptionDifference} />
  ),
})
